// @flow

import BaseChannel from './BaseChannel';

export default class LegacyUserChannel extends BaseChannel {
  static channelName = "LegacyUserChannel"
}
